import { createSlice } from '@reduxjs/toolkit';
import { athkarEsbahWMasaa } from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';



const card = athkarEsbahWMasaa.data.filter(card => card.type === "sabah" || card.type === "all");

const modifiedCards = card.map(card => ({
  ...card,
  id: `${card.id}-sabah`
}));

const athkarEsabahSlice = createSlice({
  name: 'athkarEsabah',
  initialState: {
    value: 0,
    data: modifiedCards,
  },
  reducers: {
    showInfoS: showInfoAct,
    numDecreaseS: numDecreaseAct,
    prograssNumS:prograssNum,

  },
});

export const { showInfoS,numDecreaseS,prograssNumS } = athkarEsabahSlice.actions;
export default athkarEsabahSlice.reducer;